import {
  pointsOnOrderDeliveryActivityJsonSchema,
  pointsOnOrderDeliveryActivityUiSchema
} from '@/services/schema/activity'
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'

const PointsOnOrderDeliverySetUp = ({formData, handleFormChange}) => {
  return (
    <>
      <JsonFormsWrapper
        jsonschema={pointsOnOrderDeliveryActivityJsonSchema}
        uischema={pointsOnOrderDeliveryActivityUiSchema(formData)}
        data={formData}
        onChange={handleFormChange}
      />
    </>
  )
}

export default PointsOnOrderDeliverySetUp
